module.exports = __webpack_public_path__ + "static/media/geek.8fe7633b.jpg";